<app-header></app-header>
<main class="pages">
    <section class="gradient-light">
        <div class="container pt-lg-5">
            <div class="row align-items-center">
                <div class="col-md-6">
                    <!-- <nav aria-label="breadcrumb text-center">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item"><a routerLink="">Home</a></li>
                            <li class="breadcrumb-item active" aria-current="page">Retails and Manufacturing </li>
                        </ol>
                    </nav> -->
                    <h1 alt="Manufacturing Customer Survey" class="h1-title">Working on new product development or Go to market Strategy?</h1>
                    <p class="sub-text mt-3">Our customer centric feedback survey can help you achieve just what you are looking for in your customers and products.</p>
                    <div class="mt-lg-5">
                        <a title="" class="btn btn-lg btn-success px-4 text-uppercase  mr-lg-2" data-toggle="modal" data-target="#callBack" id="callback">
                            Request a Demo</a>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="page-banner-img">
                        <img class="img-fluid mt-3 mt-lg-0" alt="Retail Survey" title="" src="assets/market-research-2.svg">
                    </div>
                </div>
            </div>
        </div>
    </section>


    <section class="mb-5 pb-5">
        <div class="container ">
            <div class="col-md-12">
                <div class="featured card border-0 shadow mt-lg-5">
                    <div class="card-body">
                        <h2 alt="retail survey companies" class="text-center headings mb-4">Retail and Manufacturing</h2>
                        <p class="text-center sub-text">Be it your existing product satisfaction survey, brand awareness survey or a survey for understanding your competition, CViewSurvey provides solutions for all such types of objectives. They help you learn the ins an outs of your
                            customer for an uninterrupted experience.</p>
                    </div>
                    <!-- play-video -->
                    <div class="play-video">
                        <a class="video-play-button" (click)="scroll(target)">
                            <span></span>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <!-- category-section -->
    <section class="mt-5 mb-lg-5 pt-lg-5 pb-lg-5">
        <div class="container mb-lg-5">
            <h3 alt="Product Satisfaction Survey" class="text-center">Our retail and manufacturing surveys can benefit you in ways such as:</h3>
        </div>

        <div class="features-screenshot-right">
            <div class="container">
                <div class="row align-items-center">
                    <div class="col-md-6">
                        <div class="lazy-image-wrapper loaded">
                            <img class="img-fluid px-lg-5 mb-0 mb-lg-3" alt="Manufacturing Survey" src="assets/new-arrival.svg">
                        </div>
                    </div>

                    <div class="col-md-6">
                        <h3 alt="Product Satisfaction Survey" class="feature-heading">NEW PRODUCT LAUNCH</h3>
                        <p class="sub-text text-justify">Rather than building a product or service and then finding customers, it is wise to conduct a survey and substantiate the demand and profitability of your product before investing time and money. Listen to the wants and needs of
                            your customers and give them exactly what they want.</p>

                        <h5 class="feature-heading mt-4">PRODUCT AWARENESS</h5>
                        <p class="sub-text text-justify">Product awareness is often the first step in driving marketing goals, it helps your clients understand and become comfortable with your product. Understand your target audience for a better and smooth transition of product knowledge.</p>
                    </div>
                </div>
            </div>
        </div>

        <div class="features-screenshot-left">
            <div class="container">
                <div class="row align-items-center mob-column-reverse">
                    <div class="col-md-6">
                        <h3 alt="Product Satisfaction Survey" class="feature-heading">UNDERSTAND THE CUSTOMER’S BUYING TREND</h3>
                        <p class="sub-text text-justify">Understanding customers' buying patterns is the key to reach and engage your clients and make them purchase your product. You can capitalize on consumer’s personal experiences based on the data collected with these market surveys.</p>

                        <h5 class="feature-heading mt-4">BUILDING STRONG RELATIONSHIP</h5>
                        <p class="sub-text text-justify">If you develop a relationship with your client, they tend to be loyal towards your product and also act as promoters for your brand. Whenever you listen to your customer, you tend to bring out new opportunities and scope of improvement
                            from them that can be useful in the future. Make them understand that they have your ears always.</p>
                    </div>
                    <div class="col-md-6">
                        <div class="lazy-image-wrapper loaded">
                            <img class="img-fluid px-lg-5 mb-0 mb-lg-3" alt="retail customer survey" src="assets/customer-relationship.svg">
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="features-screenshot-right " style="margin-bottom: 60px;">
            <div class="container">
                <div class="row align-items-center">
                    <div class="col-md-6">
                        <div class="lazy-image-wrapper loaded">
                            <img class="img-fluid px-lg-5 mb-0 mb-lg-3" alt="survey retail" src="assets/competitor-analysis-01.svg">
                        </div>
                    </div>

                    <div class="col-md-6">
                        <h3 alt="Product Satisfaction Survey" class="feature-heading">COMPETITOR ANALYSIS</h3>
                        <p class="sub-text text-justify">By conducting this survey you can get an insight about your competitor and their strategy, this helps you to screen their plan. It helps you identify your ground of improvement and act better than your competitor.</p>
                    </div>
                </div>
            </div>
        </div>

        <div class="container my-5 d-none">
            <p class="text-center sub-text">CViewSurvey provides you unlimited templates and customized surveys; we assure you the best outcome through real-time data collection and robust analytics.</p>
        </div>
    </section>

    <!-- video-section -->
    <section #target class="bg-primary py-lg-5 mt-lg-5 position-relative">
        <div class="container">
            <div class="row">
                <div class="col-lg-8 offset-lg-2">
                    <div class="solution-video">
                        <!-- <video class="embed-responsive embed-responsive-16by9" autoplay [muted]="'muted'" controls loop>
                            <source class="embed-responsive-item" src="assets/video/how-cview-works.mp4"
                                type="video/mp4">
                            Your browser does not support the video tag.
                        </video> -->
                        <iframe width="580" height="335" [src]="safeURL" frameborder="0" allowfullscreen></iframe>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <!-- 
    <section class="py-lg-5">
        <div class="container">
            <h4 class="feature-heading headings text-center text-capitalize">uses of market research surveys</h4>
            <p class="sub-text mt-3  text-center">Market research surveys can be beneficial for your business planning,
                wehave listed a few ways on how you can use market research to your benefit. </p>

            <div class="row py-lg-3">
                <ul class="col-lg-4 list-unstyled">
                    <li class="border-top border-bottom py-2">
                        <img src="../../../assets/bullet.svg" class="mr-3" alt="consumer research survey">
                        <span>Reach a specific audience. </span>
                    </li>
                    <li class="border-bottom py-2">
                        <img src="../../../assets/bullet.svg" class="mr-3" alt="market survey for new business">
                        <span>Researching and analyzing target marketing </span>
                    </li>
                    <li class="border-bottom py-2">
                        <img src="../../../assets/bullet.svg" class="mr-3" alt="marketing research surveys">
                        <span>Evaluating awareness of your brand.</span>
                    </li>
                </ul>
                <ul class="col-lg-4 list-unstyled">
                    <li class="border-top border-bottom py-2">
                        <img src="../../../assets/bullet.svg" class="mr-3" alt="marketing research surveys">
                        <span>Getting insights on your product.</span>
                    </li>
                    <li class="border-bottom py-2">
                        <img src="../../../assets/bullet.svg" class="mr-3" alt="marketing survey">
                        <span>Gain impressions on your future product. </span>
                    </li>
                    <li class="border-bottom py-2">
                        <img src="../../../assets/bullet.svg" class="mr-3" alt="marketing survey">
                        <span>Know your competitors. </span>
                    </li>
                </ul>
                <ul class="col-lg-4 list-unstyled">
                    <li class="border-top border-bottom py-2">
                        <img src="../../../assets/bullet.svg" class="mr-3" alt="marketing survey">
                        <span>Customer geometrical.</span>
                    </li>
                    <li class="border-bottom py-2">
                        <img src="../../../assets/bullet.svg" class="mr-3" alt="market research survey">
                        <span>Deciding creative assets.</span>
                    </li>
                </ul>
            </div>
            <p class="sub-text">
                Regardless of how you conduct your market research survey or what is the purpose of conducting, make
                sure you use quality content and listen to what your customers want.
            </p>
        </div>
    </section> -->

</main>
<app-footer></app-footer>